import { SettingLayoutComponentId } from '@starsoft/common/models/setting/layout/component/componentId.enum';
import { useResolvedTheme } from '../useResolvedTheme';
import { ComponentType } from '@starsoft/common/models';

export function useComponentVariant(typeId: ComponentType): string {
  const { components } = useResolvedTheme();
  const componentVariant: string = components
    .get(typeId?.toString())
    ?.toString();

  return componentVariant;
}
